const branchLevel = ["branch"];

// Branch Routes

const branchPriceMgt = {
  route: "Price management",
  path: "",
  routeIcon: "money-recive.svg",
  activeRouteIcon: "money-recive-active.svg",
  children: [
    {
      route: "Price Log",
      path: "/price-log",
    },
    {
      route: "Price change status",
      path: "/price-change-status",
    },
    {
      route: "Shutdown Pump",
      path: "/shutdown-pump",
    },
    {
      route: "Price approval",
      path: "/price-approval",

      roles: [
        "ApprovePrice",
        "CompanyApproval",
        "BranchApproval",
        "GroupApproval",
      ],
    },

    // {
    //   route: "Manage approval",
    //   path: "/manage-approval",

    //   roles: [
    //     "ApprovePrice",
    //     "CompanyApproval",
    //     "BranchApproval",
    //     "GroupApproval",
    //   ],
    // },
  ],
  name: [
    "price-log",
    "price-approval",
    "price-change-status",
    "shutdown-pump",
    "price-approval-details",
  ],
  view: ["station"],
  levels: branchLevel,
  roles: [
    "Price",
    "ApprovePrice",
    "CompanyPrice",
    "BranchPrice",
    "GroupPrice",
    "CompanyApproval",
    "BranchApproval",
    "GroupApproval",
  ],
};

const branchReports = [
  {
    route: "Cashflow",
    path: "/station/cashflow",
    routeIcon: "dollar-circle@2x.svg",
    activeRouteIcon: "active-dollar-circle.png",
    name: ["station-cashflow"],
    children: [],
    view: ["station"],
    levels: branchLevel,

    roles: ["Account", "BranchReport"],
  },
  {
    route: "Sales report",
    path: "",
    routeIcon: "inactive-globe-alt.svg",
    activeRouteIcon: "globe-alt.svg",
    children: [
      {
        route: "Sales transactions ",
        path: "/station/sales-transactions",
      },
      {
        route: "End of day report",
        path: "/station/end-of-day-report",
      },
      {
        route: "Pump variance ",
        path: "/station/pump-variance",
      },
      {
        route: "Tank variance ",
        path: "/station/tank-variance",
      },
      {
        route: "POS sales",
        path: "/station-pos-sales",
      },
      {
        route: "Remis sales",
        path: "/remis-sales-details",
      },
    ],
    name: [
      "station-sales-transactions",
      "station-end-of-day-report",
      "station-tank-variance",
      "station-pump-variance",
      "station-pos-sales",
      "remis-sales-details",
    ],
    view: ["station"],
    levels: branchLevel,
    roles: ["BranchReport"],
  },
  {
    route: "Inventory report",
    path: "",
    routeIcon: "inactive-receipt-2.svg",
    activeRouteIcon: "receipt-2.svg",
    children: [
      {
        route: "Inventory report ",
        path: "/inventory-report",
      },
      {
        route: "Product discharged",
        path: "/product-discharged",
      },
      {
        route: "Stock valuation ",
        path: "/stock-valuation",
      },
      {
        route: "Tank report",
        path: "/tank-report",
      },
      {
        route: "Suffciency metrics ",
        path: "/branch-sufficiency-metrics",
      },
      // {
      //   route: "Product received  ",
      //   path: "/product-received",
      // },

      // {
      //   route: "Send branch report",
      //   path: "/branch-reports",
      // },
    ],
    name: [
      "product-stock",
      "product-discharged",
      "stock-valuation",
      "product-received",
    ],
    view: ["station"],
    levels: branchLevel,
    roles: ["BranchReport"],
  },
];

const branchPumpMgt = {
  route: "Pump management",
  path: "",
  routeIcon: "gas-station.svg",
  activeRouteIcon: "active-gas-station.svg",
  children: [
    {
      route: "Pump management",
      path: "/pump-management",
      roles: ["BranchPump"],
    },
    {
      route: "Pump code",
      path: "/pump-code",
      roles: ["BranchPump"],
    },
    // {
    //   route: "Pump Mode",
    //   path: "/pump-mode",

    //   roles: ["BranchPump"],
    // },
  ],
  name: [
    "pump-management",
    "pump-details",
    "pump-code",
    "pump-mode",
    "pump-mode-details",
    "PumpModeChangeInitiator",
    "PumpModeChangeApprover",
  ],
  view: ["station"],
  levels: branchLevel,
  roles: ["BranchPump", "Report", "SalesReport", "PumpVariance"],
};
const branchTankMgt = {
  route: "Tank management",
  path: "/tank-management",
  routeIcon: "layer.svg",
  activeRouteIcon: "layer-active.svg",
  children: [],
  name: ["tank-management", "tank-management-details", "tank-daily-report"],
  view: ["station"],
  levels: branchLevel,
  roles: ["BranchTank"],
  view: ["station"],
};

// 🚨 Drystock

// const branchDrystock = {
//   route: "Dry stock",
//   path: "",
//   routeIcon: "shopping-cart.svg",
//   activeRouteIcon: "active-shopping-cart.svg",
//   children: [
//     {
//       route: "Supply",
//       path: "/dry-stock-supply",
//     },
//     {
//       route: "Sales",
//       path: "/dry-stock-sales",
//     },
//     {
//       route: "Branch product stock",
//       path: "/branch-product-stock",
//     },
//   ],
//   name: [
//     "dry-stock",
//     "dry-stock-product",
//     "dry-stock-supply",
//     "dry-stock-sales",
//     "dry-stock-stock",
//     "dry-stock-product-cat",
//     "drystock-single-product",
//     "dry-stock-supply-details",
//     "dry-stock-sales-details",
//   ],
//   view: ["drystock"],
//   levels: branchLevel,
//   roles: ["canmanagedrystock", "viewdrystockproducts", "canViewNonWetProducts"],
// };

const drystockSupply = {
  route: "Supply",
  path: "/dry-stock-supply",
  routeIcon: "grey-send-sqaure-2.svg",
  activeRouteIcon: "green-send-sqaure-2.svg",
  children: [],
  name: ["dry-stock-supply", "dry-stock-supply-details"],
  view: ["drystock"],
  levels: branchLevel,
  roles: ["canmanagedrystock", "viewdrystockproducts", "canViewNonWetProducts"],
};

const drystockSales = {
  route: "Sales",
  path: "/dry-stock-sales",
  routeIcon: "money-recive.svg",
  activeRouteIcon: "active-money-recive.svg",
  children: [],
  name: ["dry-stock-sales", "dry-stock-sales-details"],
  view: ["drystock"],
  levels: branchLevel,
  roles: ["canmanagedrystock", "viewdrystockproducts", "canViewNonWetProducts"],
};

const drystockStationProductStock = {
  route: "Product stock",
  path: "/branch-product-stock",
  routeIcon: "notification-bing.svg",
  activeRouteIcon: "green-notification-bing.svg",
  children: [],
  name: ["dry-stock-stock", "dry-stock-stock-sale"],
  view: ["drystock"],
  levels: branchLevel,
  roles: ["canmanagedrystock", "viewdrystockproducts", "canViewNonWetProducts"],
};

const branchBankDeposit = {
  route: "Bank Deposit",
  path: "/branch-bank-deposit",
  routeIcon: "money-add.svg",
  activeRouteIcon: "active-money-add.svg",
  children: [],
  name: ["bank-deposit-detail"],
  view: ["station"],
  levels: branchLevel,
  roles: ["ManageBankDeposit"],
};
const branchManualRecords = {
  route: "Manual Records",
  path: "",
  routeIcon: "document-normal.svg",
  activeRouteIcon: "document-normal.svg",
  children: [
    {
      route: "Manual Records",
      path: "/manual-records",
    },
    {
      route: "Rejected Records",
      path: "/rejected-records",
    },
    {
      route: "Record Dippings",
      path: "/record-dippings",
    },
    // {
    //   route: "Record List",
    //   path: "/manual-record-list",
    // },
    // {
    //   route: "Resolved Totalizer",
    //   path: "/resolved-totalizer",
    //   view: [],
    // },
  ],
  name: [
    "manual-records",
    "rejected-records",
    "record-dippings",
    "manual-record-list",
    // "resolved-totalizer",
  ],
  view: ["station"],
  levels: branchLevel,
  roles: ["manualRecords"],
};

// 🚨 Staff Mgt
// const brancHStaffMgt = {
//   route: "Staff Management",
//   path: "/staff-management",
//   routeIcon: "profile-2user.svg",
//   activeRouteIcon: "profile-2user--filled.svg",
//   children: [
//     {
//       route: "List of staff",
//       path: "/staff-management",
//     },
//     {
//       route: "Leave",
//       path: "/leave-management",
//     },
//     {
//       route: "Salary",
//       path: "/salary-management",
//     },
//     {
//       route: "Payroll",
//       path: "/payroll",
//     },
//     {
//       route: "Staff comparison",
//       path: "/staff-comparison",
//     },
//   ],
//   name: [
//     "staff-management",
//     "leave-management",
//     "salary-management",
//     "performance-evaluation",
//   ],
//   view: ["staffManangement"],
//   levels: branchLevel,
//   roles: ["ManageStaff"],
// };

const staffList = {
  route: "Staff list",
  path: "/staff-management",
  routeIcon: "profile-2user.svg",
  activeRouteIcon: "profile-2user--filled.svg",
  children: [],
  name: ["staff-management"],
  levels: branchLevel,
  roles: ["ManageStaff"],
  view: ["staffManangement"],
};

const StaffLeave = {
  route: "Leave",
  path: "/leave-management",
  routeIcon: "user-minus.svg",
  activeRouteIcon: "active-user-minus.svg",
  children: [],
  name: ["leave-management"],
  levels: branchLevel,
  roles: ["ManageStaff"],
  view: ["staffManangement"],
};

const StaffSalary = {
  route: "Salary",
  path: "/salary-management",
  routeIcon: "money-recive.svg",
  activeRouteIcon: "money-recive-active.svg",
  children: [],
  name: ["salary-management"],
  levels: branchLevel,
  roles: ["ManageStaff"],
  view: ["staffManangement"],
};

const StaffPayroll = {
  route: "Payroll",
  path: "/payroll",
  routeIcon: "grey-status-up.svg",
  activeRouteIcon: "green-status-up.svg",
  children: [],
  name: ["payroll"],
  levels: branchLevel,
  roles: ["ManageStaff"],
  view: ["staffManangement"],
};

const StaffComparison = {
  route: "Staff comparison",
  path: "/staff-comparison",
  routeIcon: "grey-user-edit.svg",
  activeRouteIcon: "green-user-edit.png",
  children: [],
  name: ["staff-comparison"],
  levels: branchLevel,
  roles: ["ManageStaff"],
  view: ["staffManangement"],
};

//

const branchServices = {
  route: "Services",
  path: "/services",
  routeIcon: "category-2.svg",
  activeRouteIcon: "category-2-active.svg",
  children: [],
  name: ["services"],
  view: ["stationLease"],
  levels: branchLevel,
  roles: ["Service"],
};

const branchServicesTransactions = {
  route: "Transactions",
  path: "/services-manage-transactions",
  routeIcon: "money-add.svg",
  activeRouteIcon: "money-add-green.svg",
  children: [],
  name: ["services-transaction"],
  view: ["stationLease"],
  levels: branchLevel,
  roles: ["Service"],
};

// const branchRemis = {
//   route: "Remis(payment)",
//   path: "",
//   routeIcon: "remis-icon.svg",
//   activeRouteIcon: "active-remis-icon.svg",
//   children: [
//     {
//       route: "Remis Fueling",
//       path: "/remis/fueling-details/",
//       roles: ["ManageRemis", "RemisFueling"],
//     },
//   ],
//   name: ["remis-fueling-details"],
//   view: ["remis"],
//   levels: branchLevel,
//   roles: ["ManageRemis", "RemisFueling"],
// };
const remisTransaction = {
  route: "Remis transactions",
  path: "/remis-transactions",
  routeIcon: "remis-icon.svg",
  activeRouteIcon: "active-remis-icon.svg",
  children: [],
  name: ["remis-transactions"],
  view: ["remis"],
  levels: branchLevel,
  roles: ["ManageRemis"],
};

// const branchMaintenance = {
//   route: "Maintenance ",
//   path: "",
//   routeIcon: "wrench-screwdriver.svg",
//   activeRouteIcon: "wrench-screwdriver-active.svg",
//   children: [
//     {
//       route: "Maintenance",
//       path: "/maintenance",
//       roles: ["Maintenance", "ManageMaintenance", "ViewMaintenance"],
//     },
//     {
//       route: "Asset management",
//       path: "/station-asset",
//       roles: ["viewAsset", "ManageAsset"],
//     },
//     {
//       route: "Vendor management",
//       path: "/vendor-mgt",
//       roles: ["viewVendor", "manageVendor"],
//     },
//   ],
//   name: ["maintenance", "asssets", "vendor-mgt"],
//   view: ["maintenance"],
//   levels: branchLevel,
//   roles: [
//     "Maintenance",
//     "ManageMaintenance",
//     "ViewMaintenance",
//     "viewVendor",
//     "manageVendor",
//   ],
// };

const branchAsset = {
  route: "Asset management",
  path: "",
  routeIcon: "inactive-assetMgt.svg",
  activeRouteIcon: "active-assetMgt.svg",
  children: [
    {
      route: "Asset List",
      path: "/station-asset",
    },

    {
      route: "Asset Upload History",
      path: "/asset-upload-history",
    },
  ],
  name: ["asssets", "category-asset", "station-asset", "asset-details"],
  view: ["maintenance"],
  levels: branchLevel,
  roles: ["viewAsset", "ManageAsset"],
};

// ROUTE EXPORTS

export const branchRoutes = [
  branchPriceMgt,
  ...branchReports,
  branchPumpMgt,
  branchTankMgt,

  // 🚨 Drystock
  drystockSupply,
  drystockSales,
  drystockStationProductStock,

  // 🚨 Staff
  staffList,
  StaffLeave,
  StaffSalary,
  StaffPayroll,
  StaffComparison,

  remisTransaction,

  branchBankDeposit,
  branchManualRecords,

  // 🚨 SERVICES
  branchServices,
  branchServicesTransactions,

  branchAsset,
];
